import React, { useContext } from 'react';
import ListingImage from 'components/listing-image';
import { buildClassName } from 'utils/build-class-name';
import DeveloperIcon from 'components/icon/developer-icon';
import PreConEmptyCoverImage from 'components/pages/newhomes/components/empty-cover-image';
import { ModalContext, IModalContext } from 'contexts/modal';
import { preconIds } from 'constants/test-constants';
import styles from './style.module.scss';

import type { PreConstructionProject } from '@zoocasa/pre-construction';

interface Props {
  listing: PreConstructionProject;
}

export default function BuyNowCard({ listing }: Props) {
  const { title, coverImage, pricing, developer, location, occupancyDate } = listing;
  const item = { id: title, image: coverImage || '', alt: `${title} | Zoocasa` };
  const { openModal } = useContext(ModalContext) as IModalContext;

  const openPhotoGallery = () =>
    openModal('precon-photo-gallery', { listing });

  return (
    <div className={styles.component} onClick={openPhotoGallery} data-testid={preconIds.preconCard}>
      <div className={styles['image-wrapper']}>
        {coverImage &&
          <ListingImage
            item={item}
            onClick={() => { /* noop */ }}
            className={styles.image}
            testId={preconIds.preconCoverImage}
          />
        }
        {!coverImage &&
          <PreConEmptyCoverImage listing={listing} />
        }
        <p className={buildClassName(styles.tag, styles.date)} data-testid={preconIds.preconOccupancyDate}>
          {occupancyDate || 'TBA'}
        </p>
        <p className={buildClassName(styles.tag, styles.location)} data-testid={preconIds.preconLocation}>
          {location}
        </p>
      </div>
      <div className={styles.details}>
        <p className={styles.price} data-testid={preconIds.preconPricing}>
          {pricing || 'TBA'}
        </p>
        <div className={styles['title-dev-container']}>
          <h4 data-testid={preconIds.preconTitle}>{title}</h4>
          <p className={styles.developer} data-testid={preconIds.preconDeveloper}><DeveloperIcon /> {developer}</p>
        </div>
      </div>
    </div>
  );
}
